<template>
  <v-container id="PedidosVer" fluid>
    <v-row justify="center">
      <v-col cols="auto">
        <template>
          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Nueva Acción</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <validation-observer v-slot="{ handleSubmit }">
                    <form
                      id="nuevoSeguimiento"
                      @submit.prevent="handleSubmit(validateForm)"
                    >
                      <v-row>
                        <v-col cols="6">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            min-width="290px"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <validation-provider v-slot="{ errors }" name="fecha" rules="required">
                                <v-text-field v-model="dataForm.fecha" color="gold" :error-messages="errors" label="Fecha" readonly v-on="on" />
                              </validation-provider>
                            </template>
                            <v-date-picker
                              v-model="dataForm.fecha"
                              color="gold"
                              landscape
                              scrollable
                              locale="es-419"
                              no-title
                              @input="menu = false"
                            />
                          </v-menu>
                        </v-col>
                        <v-col cols="6">
                          <v-checkbox
                            v-model="dataForm.accion_propia_sn"
                            class="pa-0 ml-0"
                          >
                            <span
                              slot="label"
                              class="black--text"
                            >
                              Acción propia
                            </span>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row align="center" justify="center">
                        <v-col cols="12">
                          <validation-provider v-slot="{ errors }" name="descripción" rules="required|max:191">
                            <v-textarea
                              v-model="dataForm.descripcion_accion"
                              color="#ac8a2e"
                              :error-messages="errors"
                              name="input-6-1"
                              label="Descripcion"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </form>
                  </validation-observer>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      form="nuevoSeguimiento"
                      type="submit"
                    >
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>
      </v-col>
      <v-col cols="auto">
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <template>
              <v-card-title class="headline">
                ¿Realmente desea eliminar?
              </v-card-title>
            </template>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="blue darken-1"
                text
                @click="closeDelete"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="deleteItemConfirm"
              >
                Aceptar
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col
        cols="auto"
      >
        <v-dialog
          v-model="dialogCerrar"
          max-width="500px"
        >
          <v-card>
            <v-card-title class="headline">
              ¿Realmente desea cerrar el pedido?
            </v-card-title>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="blue darken-1"
                text
                @click="closeCerrar"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="cerrarPedido"
              >
                Aceptar
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row v-if="$can('M_pedidos_edita')" justify="center">
      <template v-if="!pedido_mercado.fecha_cierre">
        <v-col cols="auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark fab color="black" v-bind="attrs" v-on="on" @click="open(true)">
                <v-icon dark large>
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>Nuevo</span>
          </v-tooltip>
        </v-col>
        <v-col cols="auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark fab color="black" v-bind="attrs" v-on="on" @click="openCerrar">
                <v-icon dark large>
                  mdi-pin-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Cerrar Pedido</span>
          </v-tooltip>
        </v-col>
      </template>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col cols="auto">
        <v-chip class="ma-2" label color="grey" text-color="white">
          <v-icon left>
            mdi-account
          </v-icon>
          <span style="font-size: 130%">{{ pedido_mercado.solicitante }}</span>
        </v-chip>
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-chip
          class="ma-2"
          label
          color="gold"
          text-color="white"
        >
          <v-icon left>
            mdi-account
          </v-icon>
          <span style="font-size: 130%">PriSports</span>
        </v-chip>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-col>
        <v-timeline align-top>
          <v-timeline-item
            v-for="(seguimiento, i) in seguimientos"
            :key="i" fill-dot large
            :right="checkPropio(seguimiento)"
            :left="!checkPropio(seguimiento)"
            :color="checkPropio(seguimiento)? 'gold' : 'grey'"
          >
            <template>
              <v-card>
                <v-card-title :class="checkPropio(seguimiento)? 'gold' : 'grey'">
                  <v-row>
                    <v-col cols="auto" class="pl-0 white--text">
                      <span style="font-size: 115%"> {{ seguimiento.fecha }} </span>
                    </v-col>
                    <v-spacer />
                    <template v-if="$can('M_pedidos_edita') && !pedido_mercado.fecha_cierre && !seguimiento.primerAccion">
                      <v-col cols="auto" class="white--text">
                        <v-tooltip content-class="top" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="white--text" v-bind="attrs" v-on="on" @click.stop="open(false, seguimiento)">
                              mdi-pencil
                            </v-icon>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip content-class="top" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon class="white--text" v-bind="attrs" v-on="on" @click.stop="deleteItem(seguimiento)">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-title>
                <v-row>
                  <v-col cols="12" class="pa-0">
                    <template v-if="seguimiento.accion_propia_sn">
                      <v-card-subtitle>
                        Usuario: {{ seguimiento.user.name }}
                      </v-card-subtitle>
                      <v-divider />
                    </template>
                  </v-col>
                  <v-col cols="12" class="pa-0">
                    <v-card-text>
                      <div style="font-size: 110%">
                        {{ seguimiento.descripcion_accion }}
                      </div>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../components/confirm'

  export default {
    name: 'PedidosVer',
    components: {
      confirm,
    },
    props: {
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    data () {
      return {
        menu: false,
        dialog: false,
        dialogDelete: false,
        dialogCerrar: false,
        seguimientos: [],
        mode: '',
        dataForm: {
          id: '',
          pedido_mercado_id: '',
          fecha: '',
          accion_propia_sn: 0,
          descripcion_accion: '',
        },
        pedido_mercado: {
          id: '',
          fecha: '',
          solicitante: '',
          solicitante_contacto: '',
          club_id: '',
          fecha_cierre: '',
        },
      }
    },
    created () {
      this.getSeguimientos()
      this.getPedido()
    },
    methods: {

      getSeguimientos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/seguimiento_pedido_mercado/' + this.id }).then(response => { this.seguimientos = response })
      },

      getPedido: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/pedido_mercado/' + this.id })
          .then(response => {
            this.pedido_mercado = response
            this.dataForm.pedido_mercado_id = this.pedido_mercado.id
            this.dataForm.fecha = new Date().toJSON().slice(0, 10)
          })
      },

      checkPropio: function (item) {
        if (item.accion_propia_sn) {
          return true
        } else {
          return false
        }
      },

      open (isNew, item = null) {
        if (isNew) {
          this.mode = 'new'
        } else {
          this.mode = 'edit'
          this.dataForm = Object.assign({}, item)
        }
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.dataForm.id = ''
        this.dataForm.fecha = new Date().toJSON().slice(0, 10)
        this.dataForm.accion_propia_sn = 0
        this.dataForm.descripcion_accion = ''
      },

      openCerrar () {
        this.dialogCerrar = true
      },

      closeCerrar () {
        this.dialogCerrar = false
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'Está seguro de eliminar el registro ?', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.dataForm.id = ''
        this.dataForm.fecha = new Date().toJSON().slice(0, 10)
        this.dataForm.accion_propia_sn = 0
        this.dataForm.descripcion_accion = ''
      },

      validateForm (scope) {
        this.saveAccion()
      },

      saveAccion: async function () {
        const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/seguimiento_pedido_mercado_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de pedido exitosa'] })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
        this.getSeguimientos()
        this.close()
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/seguimiento_pedido_mercado_delete/' + item.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Acción eliminada'] })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getSeguimientos()
      },

      cerrarPedido: async function () {
        await this.$http.put('/api/pedido_mercado_cerrar/' + this.pedido_mercado.id).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Pedido cerrado'] })
          this.$router.push({ name: 'Pedidos de mercado cerrados' })
        }).catch(error => {
          if (error.response.data) {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
      },
    },
  }
</script>
